export default "__VITE_ASSET__d54d5a48__"